<script setup>
import { addContentLogAPI } from '@/api/logServiceApi';

const props = defineProps({
  modelValue: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue']);

const relationTypes = [
  { id: 'lover', label: '연인', emoji: '💖' },
  { id: 'friend', label: '친구', emoji: '🤝' },
  { id: 'business', label: '비즈니스', emoji: '💼' },
  { id: 'family', label: '가족', emoji: '🏠' },
];

const selectRelation = (id) => {
  const label = relationTypes.find((r) => r.id === id)?.label || id;
  addContentLogAPI({ contentType: 'ap_harmony_select_relation_opt3', option3: label });
  emit('update:modelValue', id);
};
</script>

<template>
  <div class="harmony-relation">
    <div class="harmony-step">
      <span class="harmony-step__label">STEP 1</span>
      <span class="harmony-step__text">관계를 선택해주세요</span>
    </div>
    <div class="harmony-relation__list">
      <button
        v-for="item in relationTypes"
        :key="item.id"
        class="harmony-relation__item"
        :class="{ 'harmony-relation__item--active': modelValue === item.id }"
        @click="selectRelation(item.id)"
      >
        <span class="harmony-relation__emoji">{{ item.emoji }}</span>
        <span class="harmony-relation__label">{{ item.label }}</span>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.harmony-step {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  &__label {
    color: #eb4c10;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }

  &__text {
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 500;
    line-height: 24px;
  }
}

.harmony-relation__list {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 12px;
}

.harmony-relation__item {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1 1 0;
  padding: 12px 8px;
  border-radius: 8px;
  border: 1px solid var(--Gray-300, #ebebeb);
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: #eb4c10;
  }

  &--active {
    border-color: #eb4c10;
    background: #fff8f5;

    .harmony-relation__label {
      color: #eb4c10;
    }
  }
}

.harmony-relation__emoji {
  font-size: 20px;
  line-height: 25px;
}

.harmony-relation__label {
  color: var(--Gray-800, #333);
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
}

@media (max-width: 360px) {
  .harmony-relation__list {
    gap: 6px;
  }

  .harmony-relation__item {
    padding: 10px 4px;
  }

  .harmony-relation__label {
    font-size: 13px;
  }

  .harmony-relation__emoji {
    font-size: 18px;
  }
}

@media (min-width: 768px) {
  .harmony-relation__item {
    flex-direction: row;
    padding: 12px 15px;
  }
}
</style>
